// OpportunityPage.jsx
import React, { useEffect, useMemo, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  InputGroup,
  Badge,
  Stack,
} from 'react-bootstrap';
import OpportunityHeader from './OpportunityHeader';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { add_product_to_opp, check_task, load_opportunity, load_opportunity_log, load_opportunity_products, load_products, remove_product_to_opp, send_newLogEntry } from '../../../utils/crm_services';
import { create_new_task, get_all_members } from '../../../utils/talent_services';
import Select from 'react-select';
import Modal_proyectos from '../../menus/Modal';
import UserAvatar from '../dashboard/UserAvatar';

export default function OpportunityPage({usr_type, usr_id, cards = []}) {
  const token = localStorage.getItem("token");

  // Estado del header
  const [status, setStatus] = useState('Draft');
 const navigate = useNavigate();
  // Formulario
  const [contactName, setContactName] = useState('');
  const [newUnits, setNewUnits] = useState('');
  const [selectedNewProduct, setSelectedNewProduct] = useState('');
  const [opportunitySize, setOpportunitySize] = useState(0);
  const [productOptions, setproductOptions] = useState([]);
  const [productList, setproductList] = useState([]);

  const [newOpportunity, setNewOpportunity] = useState(false);

  const [searchParams] = useSearchParams();
  const opportunity_id = searchParams.get("id");
  const originalChannel_id = searchParams.get("channel_id");
 
    // --- Estados adicionales ---
  // Estado para saber si el log es público (true) o privado (false)
  const [isPrivate, setIsPrivate] = useState(false); 
  // Estado para saber si es una tarea
  const [isTask, setIsTask] = useState(false);
  // Estado para la fecha de vencimiento
  const [expiryDate, setExpiryDate] = useState('');
  const [taskTitle, setTaskTitle] = useState('');
  const [newTaskAssignUsrId, setNewTaskAssignUsrId] = useState(() => (usr_id != null ? Number(usr_id) : null));
  const [assigneePickerOpen, setAssigneePickerOpen] = useState(false);
  const [assigneeSearch, setAssigneeSearch] = useState('');
  const [assigneeOptions, setAssigneeOptions] = useState([]);

  const getProductByValue = (value) => {
    // Si el valor es null o undefined, retorna null para limpiar el Select
    if (value === null || value === undefined) {
      return null;
    }
    // Busca la opción correspondiente en productOptions
    return productOptions.find(option => option.value === value) || null;
  };
  


  //LOADING
    useEffect(() => {
      if (opportunity_id !== null) {
        if(opportunity_id==="new"){
            setNewOpportunity(true);
        }else{
            setNewOpportunity(false);
        }
      }
    }, [opportunity_id]); 

   

  async function load_log() {
    const opp_log = await load_opportunity_log(token,opportunity_id);
    if (opp_log==="INVALID"){
        navigate("/");
    }else{

     const templog= opp_log.map((celement, index) => {
       return {
           id: celement.id,
           issue_date: celement.issue_date,
           description: celement.description,
           is_private: celement.is_private,
           type_name: celement.type_name,
           issue_type: celement.type,
           expiryDate: celement.expiry_date,
           user_by: celement.usr_name,
           done: parseInt(celement.done)==1?true:false,
           index:index
       };
     });

      setLog( templog);
        
    }
}
  
  async function fetch_opportunity_products() {
           const opp_product_list = await load_opportunity_products(token,opportunity_id);
           if (opp_product_list==="INVALID"){
               navigate("/");
           }else{

            let opportunitySize =0;
            const tempproducts= opp_product_list.map((celement, index) => {
              opportunitySize += parseInt( celement.units) * parseFloat (celement.exw_price);
              return {
                  id: celement.id,
                  units: celement.units,
                  name: celement.name,
                  description: celement.prod_description,
                  exw_price: celement.exw_price,
                  index:index
              };
            });
  
             setproductList( tempproducts);
             setOpportunitySize(opportunitySize);
               
           }
  }
  

  const addItem = () =>{

     async function fetchAddProduct() {
            const cardList = await add_product_to_opp(token,opportunity_id, selectedNewProduct, newUnits);
            if (cardList==="INVALID"){
                navigate("/");
            }else{
              setSelectedNewProduct(null);
              setNewUnits(0)
              fetch_opportunity_products();
            }
        }
        fetchAddProduct();
  }

  
  async function fetchRemoveItem(id) {
    const cardList = await remove_product_to_opp(token,id);
    if (cardList==="INVALID"){
        navigate("/");
    }else{
      fetch_opportunity_products();
    }
}



  // Log
  const [logEntry, setLogEntry] = useState('');
  const [log, setLog] = useState([]);
  const [opportunityName, setOpportunityName] = useState('');

  const sendLog = () => {
    if (!logEntry.trim()) return;
    if (isTask && !taskTitle.trim()) return;

    sendNewLogEntry();
    setLogEntry('');
  };

  const defaultAssigneeUsrId = usr_id != null && !Number.isNaN(Number(usr_id)) ? Number(usr_id) : null;

  const selectedAssignee = useMemo(
    () => assigneeOptions.find((opt) => opt.usr_id === newTaskAssignUsrId) || null,
    [assigneeOptions, newTaskAssignUsrId]
  );

  const filteredAssigneeOptions = useMemo(() => {
    const term = assigneeSearch.trim().toLowerCase();
    if (!term) return assigneeOptions;
    return assigneeOptions.filter((opt) => {
      const name = (opt.displayName || '').toLowerCase();
      const email = (opt.email || '').toLowerCase();
      return name.includes(term) || email.includes(term);
    });
  }, [assigneeOptions, assigneeSearch]);

  const resetTaskControls = () => {
    setIsTask(false);
    setTaskTitle('');
    setExpiryDate('');
    setAssigneeSearch('');
    setAssigneePickerOpen(false);
    setNewTaskAssignUsrId(defaultAssigneeUsrId);
  };

  const handleTaskToggle = (checked) => {
    setIsTask(checked);
    if (!checked) {
      setTaskTitle('');
      setExpiryDate('');
      setAssigneeSearch('');
      setAssigneePickerOpen(false);
      setNewTaskAssignUsrId(defaultAssigneeUsrId);
    }
  };

  useEffect(() => {
    setNewTaskAssignUsrId(defaultAssigneeUsrId);
  }, [defaultAssigneeUsrId]);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      const list = await get_all_members(token);
      if (cancelled) return;
      if (list === 'INVALID') {
        navigate('/');
        return;
      }
      if (!Array.isArray(list)) {
        setAssigneeOptions([]);
        return;
      }
      const normalized = list
        .map((row) => {
          const rawId = row.usr_id;
          const uid = rawId != null && rawId !== '' ? Number(rawId) : null;
          const name = (row.usr_name || '').trim();
          const email = (row.email || '').trim();
          const displayName = name || email || `Usuario ${uid ?? ''}`.trim();
          return { usr_id: uid, displayName, email };
        })
        .filter((x) => x.usr_id != null && !Number.isNaN(x.usr_id));

      if (defaultAssigneeUsrId != null && !normalized.some((x) => x.usr_id === defaultAssigneeUsrId)) {
        normalized.unshift({ usr_id: defaultAssigneeUsrId, displayName: 'Tú', email: '' });
      }

      const deduped = [];
      const seen = new Set();
      normalized.forEach((row) => {
        if (seen.has(row.usr_id)) return;
        seen.add(row.usr_id);
        deduped.push(row);
      });

      setAssigneeOptions(deduped);
    })();
    return () => {
      cancelled = true;
    };
  }, [token, navigate, defaultAssigneeUsrId]);

  

   useEffect(() => {

    if (opportunity_id !== null && token != null) {
      if(opportunity_id==="new"){
          setNewOpportunity(true);
          setOpportunityName('');
      }else{
        setNewOpportunity(false);
        fetchLoadProducts();
        fetch_opportunity_products();
        load_log();
        load_opportunity(token, opportunity_id).then((r) => {
          if (r && r.opp_data && r.opp_data[0] && r.opp_data[0].name) {
            setOpportunityName(r.opp_data[0].name);
          } else {
            setOpportunityName('');
          }
        }).catch(() => setOpportunityName(''));
      }
    }

  }, [token, opportunity_id]);
  

    
  async function sendNewLogEntry() {
    const productList = await send_newLogEntry(token, opportunity_id, logEntry, isTask ? 3 : 2, isPrivate, expiryDate);
    if (productList === "INVALID") {
      navigate("/");
      return;
    }
    if (isTask && taskTitle.trim() !== '') {
      const assignId = newTaskAssignUsrId != null && !Number.isNaN(Number(newTaskAssignUsrId))
        ? Number(newTaskAssignUsrId)
        : defaultAssigneeUsrId;
      const taskName = taskTitle.trim();
      const createResult = await create_new_task(token, taskName, {
        task_description: logEntry,
        opportunity_id: opportunity_id,
        due_date: expiryDate && expiryDate.trim() !== '' ? expiryDate : undefined,
        assignee_usr_id: assignId,
      });
      if (createResult === "INVALID") {
        navigate("/");
        return;
      }
    }
    load_log();
    resetTaskControls();
  }


  async function fetchLoadProducts() {
          const productList = await load_products(token);
          if (productList==="INVALID"){
              navigate("/");
          }else{
    
             const tempproducts= productList.map((celement, index) => {
              return {
                  value: celement.id,
                  label: celement.name,
                  description: celement.description,
                  exw_price: celement.exw_price,
                  index:index
              };
            });
  
             setproductOptions( tempproducts);
  
          }
      }

  async function handleTaskCompletion  (taskId, newStatus) {
         const opp_log = await check_task(token,taskId, newStatus);
    if (opp_log==="INVALID"){
        navigate("/");

    }else{
      load_log();
    }
  }
  

  return (
    <Container fluid className="py-4">
      {/* HEADER */}
      <Row className="mb-4">
        <Col>
        {token!="" &&
          <OpportunityHeader
            originalChannel_id={originalChannel_id}
            status={status}
            onStatusChange={setStatus}
            amount={80000}
            token={token}
            usr_type={usr_type}
            newOpportunity={newOpportunity}
            opportunity_id = {opportunity_id}
            usr_id={usr_id}
            cards={cards}
          />
        }
        </Col>
      </Row>

     {!newOpportunity && 
     <div>
      {/* FORMULARIO */}
      <Row className="gy-4 mb-4">
        {/* Fila 1: Contact Name | Phone | Protected until */}
        

       
      </Row>

      {parseInt(usr_type) ==0 &&(
      <Row className="mb-3"> {/* Added mb-3 for some margin below the heading */}
        <Col className="text-end"> {/* Align to the right for a common financial display */}
          {/* You can add a label if it's not immediately obvious what the number represents */}
          <h4 className="mb-0">
            Opportunity Amount:{' '}
            <span className="text-success fw-bold"> {/* Make it green and bold */}
              {opportunitySize.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 0,
              })}
            </span>
          </h4>
        </Col>
      </Row>
    )}
      {/* TABLA DE PRODUCTOS */}
      <Row className="mb-4">
        <Col>
       
          <div className="table-wrapper">
            <Table bordered size="sm">
              <thead>
                <tr>
                  <th style={{ width: '40%' }}>Product</th>
                  <th style={{ width: '10%' }}>Units</th>
                  <th style={{ width: '5%' }}></th>
                </tr>
              </thead>
              <tbody>
                {productList.map((it) => (
                  <tr key={it.id}>
                    <td>
                      {it.name}
                    </td>
                    <td>
                      {it.units}
                    </td>
                 
                   
                    <td className="text-center">
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => fetchRemoveItem(it.id)}
                      >
                        &minus;
                      </Button>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td >
                  <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            options={productOptions}
                            isLoading={productOptions.length === 0}
                            onChange={(selectedOption) =>{
                              setSelectedNewProduct(selectedOption.value);
                                }}
                            value={getProductByValue(selectedNewProduct)}
                            placeholder="Producto..."
                            isSearchable
                            menuPortalTarget={document.body}
                            styles={{
                                container: (provided) => ({
                                  ...provided,
                                  minWidth: 100, // o usa width: '100%' para expansión completa
                                  flex: 1,       // permite que crezca en d-flex
                                }),
                                  menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999 // Un valor alto para asegurar que aparezca encima de todo
                                  }),
                                  
                              }}
                        />
                  </td>
                  <td>
                      <Form.Control
                        size="sm"
                        type="number"
                        value={newUnits}
                        onChange={(e) => setNewUnits( e.target.value)}
                      />
                    </td>
                  <td className="text-center">
                    <Button variant="outline-success" size="sm" onClick={addItem}>
                      Agregar
                    </Button>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>

      {/* OPPORTUNITY LOG */}
      <Row className="mt-4 text-start">
        <Col>
          <Form.Label>Opportunity Log:</Form.Label>
            <div className="p-3 border bg-light rounded">
      <Row className="g-4">
        {/* === COLUMNA IZQUIERDA: ÁREA DE TEXTO (Sin cambios) === */}
        <Col md={7}>
          {isTask && (
            <Form.Group controlId="taskTitle" className="mb-3">
              <Form.Label className="fw-bold">Título de la tarea</Form.Label>
              <Form.Control
                type="text"
                value={taskTitle}
                onChange={(e) => setTaskTitle(e.target.value)}
                placeholder="Nombre corto de la tarea"
                required
              />
              <Form.Text className="text-muted">
                Obligatorio si marcas «Es una tarea». Se usa como nombre de la tarea en Talent.
              </Form.Text>
            </Form.Group>
          )}
          <Form.Group controlId="logEntryText">
            <Form.Label className="fw-bold">
              {isTask ? 'Descripción de la tarea' : 'Detalle de la Entrada'}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              placeholder={
                isTask
                  ? 'Describe la tarea (se guardará como descripción en Talent y en el log de la oportunidad)...'
                  : 'Añade una entrada detallada al log...'
              }
              value={logEntry}
              onChange={(e) => setLogEntry(e.target.value)}
            />
          </Form.Group>
        </Col>

        {/* === COLUMNA DERECHA: PANEL DE OPCIONES (Ajustado) === */}
        <Col md={5}>
            <Form.Label className="fw-bold">Opciones</Form.Label>
            
            {/* --- INICIO DEL CAMBIO: Fila para las opciones principales --- */}
            <Row className="mt-2">
                <Col>
                    <Form.Check 
                        type="switch"
                        id="public-switch"
                        label="Privada"
                        checked={isPrivate}
                        onChange={(e) => setIsPrivate(e.target.checked)}
                    />
                </Col>
                <Col>
                    <Form.Check 
                        type="checkbox"
                        id="task-checkbox"
                        label="Es una tarea"
                        checked={isTask}
                        onChange={(e) => handleTaskToggle(e.target.checked)}
                    />
                </Col>
            </Row>
            {/* --- FIN DEL CAMBIO --- */}
            
            {/* La fecha aparece debajo si la tarea está marcada */}
            {isTask && (
                <>
                  <Form.Group controlId="taskAssignee" className="mt-3">
                    <Form.Label>Responsable</Form.Label>
                    <Button
                      variant="outline-secondary"
                      className="w-100 d-flex align-items-center justify-content-between"
                      onClick={() => setAssigneePickerOpen(true)}
                    >
                      <span className="d-inline-flex align-items-center gap-2 text-truncate">
                        <UserAvatar
                          usr_id={selectedAssignee ? selectedAssignee.usr_id : null}
                          usr_name={selectedAssignee ? selectedAssignee.displayName : 'Sin responsable'}
                        />
                        <span className="text-truncate">
                          {selectedAssignee ? selectedAssignee.displayName : 'Seleccionar responsable'}
                        </span>
                      </span>
                      <span aria-hidden="true">&rsaquo;</span>
                    </Button>
                  </Form.Group>
                  <Form.Group controlId="expiryDate" className="mt-3">
                      <Form.Label>Fecha de vencimiento</Form.Label>
                      <Form.Control 
                          type="date"
                          value={expiryDate}
                          onChange={(e) => setExpiryDate(e.target.value)}
                      />
                  </Form.Group>
                </>
            )}
        </Col>
      </Row>

      {/* === BOTÓN DE ENVÍO FINAL (Sin cambios) === */}
      <div className="d-grid mt-4">
        <Button
          variant="primary"
          size="lg"
          onClick={sendLog}
          disabled={isTask && !taskTitle.trim()}
        >
          Guardar Entrada
        </Button>
      </div>
    </div>
          <div className="log-box text-left"> {/* Aseguramos que el contenedor principal alinee su texto a la izquierda */}
            {log.length === 0 ? (
              <p className="text-gray-500 italic">No hay entradas en el registro aún.</p>
            ) : (
              log.map((l) => {
                    const expiryDate2 = new Date(l.expiryDate);
                    const today = new Date();

                    // Normalizamos ambas fechas a medianoche para comparar solo el día
                    expiryDate2.setHours(0, 0, 0, 0);
                    today.setHours(0, 0, 0, 0);

                    // Verificamos si la fecha ya pasó o es hoy
                    const isOverdueOrToday = expiryDate2 <= today;
                return(
                <div key={l.id}   className={`p-3 rounded mb-3 shadow-sm border ${parseInt(l.is_private) == 1 ? 'bg-success-subtle' : 'bg-light'}`}>
                  <div className="d-flex flex-column flex-sm-row align-items-sm-baseline mb-2 gap-3">
                    {/* Nombre del usuario */}
                    <Badge  
                      bg="warning"
                      pill
                      className="chip d-inline-flex align-items-center px-3 py-2 fs-8"
                    >
                      {l.user_by}
                    </Badge>

                    {/* Fecha */}
                    <span className="text-muted small">
                      {new Date(l.issue_date).toLocaleString()}
                    </span>

                    {/* Tipo */}
                    <Badge  
                      bg={ l.issue_type == 1 ? 'danger' :  l.issue_type == 2 ? 'info': l.issue_type == 3 ? 'secondary':'warning'}
                      pill
                      className="chip d-inline-flex align-items-center px-3 py-2 fs-8"
                    >
                      {l.type_name}
                    </Badge>
                   {l.issue_type == 3 && (
                      // Cambiamos justify-content-between por gap-3
                      <div className="d-flex align-items-center gap-3">

                        {!l.done && (
                        <span className={`small fw-bold ${isOverdueOrToday ? 'text-danger' : 'text-muted'}`}>
                          Due date: {new Date(l.expiryDate).toLocaleDateString()}
                        </span>
                        )}


                        {/* Contenedor para el checkbox (sin cambios) */}
                        <div className="d-flex align-items-center">
                          <input
                            type="checkbox"
                            className="form-check-input me-2"
                            id={`task-${l.id}`}
                            checked={l.done}
                            onChange={() => handleTaskCompletion(l.id, !l.done)}
                          />
                          <label htmlFor={`task-${l.id}`} className="form-check-label">
                            Done
                          </label>
                        </div>

                      </div>
                    )}
                  </div>

                  {/* Descripción */}
                  <p className="text-dark lh-sm text-start">{l.description}</p>
                </div>
              )})
            )}
          </div>
        </Col>
      </Row>
      </div>
    }
      <Modal_proyectos
        isOpen={assigneePickerOpen}
        onClose={() => {
          setAssigneePickerOpen(false);
          setAssigneeSearch('');
        }}
        title="Asignar tarea a"
      >
        <div className="modal-inner">
          <div className="mb-3">
            <div className="input-group input-group-sm">
              <input
                type="search"
                className="form-control"
                placeholder="Buscar por nombre o correo..."
                value={assigneeSearch}
                onChange={(e) => setAssigneeSearch(e.target.value)}
                autoFocus
              />
            </div>
          </div>
          <div className="list-group list-group-flush" style={{ maxHeight: 'min(55vh, 360px)', overflowY: 'auto' }}>
            {filteredAssigneeOptions.length === 0 ? (
              <p className="small text-muted mb-0 py-3 text-center">No hay miembros que coincidan.</p>
            ) : (
              filteredAssigneeOptions.map((opt) => (
                <button
                  key={opt.usr_id}
                  type="button"
                  className={`list-group-item list-group-item-action d-flex align-items-center gap-3 py-2 px-2${
                    opt.usr_id === newTaskAssignUsrId ? ' active' : ''
                  }`}
                  onClick={() => {
                    setNewTaskAssignUsrId(opt.usr_id);
                    setAssigneePickerOpen(false);
                    setAssigneeSearch('');
                  }}
                >
                  <UserAvatar usr_id={opt.usr_id} usr_name={opt.displayName} />
                  <span className="text-start text-truncate flex-grow-1">{opt.displayName}</span>
                </button>
              ))
            )}
          </div>
        </div>
      </Modal_proyectos>
    </Container>
  );
}
